import { Menu as BaseMenu } from '@base-ui/react/menu'

import { cn } from '@gto/ui/cn'

export const Popup = ({ className, ...props }: BaseMenu.Popup.Props) => {
  return (
    <BaseMenu.Popup
      className={cn(
        // Chosen in the 2026-07 nav-redesign menu exploration (borderless per
        // DS review — the DS doesn't use border-lines on floating surfaces).
        // No min-width here: narrow consumers (bet-size / size-pill selects)
        // must still be able to size to their content. Menus that want a floor
        // set it on their own className.
        'relative z-popover flex flex-col gap-[1px] overflow-hidden rounded-sm bg-paper-elevation4 p-1 shadow-8 outline-none',
        // Open / close animation. Base UI applies `data-starting-style` on mount
        // and `data-ending-style` during teardown — those frames act as the
        // from/to states for the CSS transition that interpolates against the
        // resting (default) values. `--transform-origin` is set on the
        // Positioner so the popup scales out from the trigger corner.
        'origin-[var(--transform-origin)] transition duration-150 ease-out',
        'data-[starting-style]:scale-95 data-[starting-style]:opacity-0',
        'data-[ending-style]:scale-95 data-[ending-style]:opacity-0',
        className,
      )}
      {...props}
    />
  )
}
